module.exports = __webpack_public_path__ + "img/footimga.f5a4a312.png";